import { App } from '@/components/App'
import { ErrorPage } from '@/pages/ErrorPage'

export default App

export const ErrorBoundary = ErrorPage
